import { CheckImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { GetFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";
import { PostFunction } from "src/utils/axios_connection";

export const GetTestimonials =
  ({ callback, page, rowsPerPage, search }) =>
  async (dispatch, getState) => {
    try {
      const query = search
        ? `?search=${search}&limit=${1000}&page=${0}`
        : `?page=${page}&limit=${rowsPerPage}`;
      let link = UrlApi.testimonials.get_admin + query;
      const response = await GetFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const DeleteTestimonials =
  ({ id, callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.testimonials.delete;
      const response = await GetFunction({
        data: {},
        Route: link + `/${id}`,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageTestimonials =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      var bodyFormData = new FormData();
      let paramID = "";
      if (editMode) {
        paramID = values?.id;
      }
      if (CheckDataIfExit(values?.name)) {
        bodyFormData.append("name", values?.name?.trim());
      }
      if (CheckDataIfExit(values?.role)) {
        bodyFormData.append("role", values?.role?.trim());
      }
      if (CheckDataIfExit(values?.comment)) {
        bodyFormData.append("comment", values?.comment?.trim());
      }
      if (
        values?.image &&
        values?.image != null &&
        values?.image != undefined &&
        CheckImageIsFile({ data: values?.image, IsBoolean: true })
      ) {
        bodyFormData.append("image", values?.image);
      } else if (editMode && !values?.image) {
        bodyFormData.append("image", "");
      }

      const response = await PostFunction({
        data: bodyFormData,
        Route: editMode
          ? `${UrlApi.testimonials.edit}/${paramID}`
          : UrlApi.testimonials.add,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        usersRoute: true,
      });

      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      console.error(err);
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditTestimonials =
  ({ callback, allData, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data;
      if (allData) {
        data = allData;
      } else {
        data = {
          [nameFailed]: dataFailed,
        };
      }
      const response = await PostFunction({
        data,
        Route: UrlApi.testimonials.edit + `/${id}`,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        usersRoute: true,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };
